'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { IS_SSR } from '../../constants';
import { type ConsentGroup, hasConsentGroup } from '../utils';
export const useConsentCategory = category => {
  const $ = _c(5);
  let t0;
  if ($[0] !== category) {
    t0 = () => {
      if (IS_SSR) {
        return false;
      }
      return hasConsentGroup({
        group: category,
        groups: window.OnetrustActiveGroups
      });
    };
    $[0] = category;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [enabled, setEnabled] = useState(t0);
  let t1;
  let t2;
  if ($[2] !== category) {
    t1 = () => {
      const readConsent = event => {
        const groups = event?.detail ?? window.OnetrustActiveGroups;
        setEnabled(hasConsentGroup({
          group: category,
          groups
        }));
      };
      readConsent();
      window.addEventListener("OneTrustGroupsUpdated", readConsent);
      return () => window.removeEventListener("OneTrustGroupsUpdated", readConsent);
    };
    t2 = [category];
    $[2] = category;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return enabled;
};